// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../platform/@jutro/cli-app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../platform/@jutro/cli-app/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__E1PAdvisorLookupComponent__filterBarContainer{margin-bottom:var(--GW-SPACING-5)}", "",{"version":3,"sources":["webpack://./src/overrides/capabilities-react/e1p-capability-policyjob-react/components/E1PAdvisorLookupComponent/E1PAdvisorLookupComponent.module.scss"],"names":[],"mappings":"AAAA,oDACE,iCAAA","sourcesContent":[".filterBarContainer {\n  margin-bottom: var(--GW-SPACING-5);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterBarContainer": "app__E1PAdvisorLookupComponent__filterBarContainer"
};
export default ___CSS_LOADER_EXPORT___;
